module.exports = __webpack_public_path__ + "img/im1.4529d419.webp";